module.exports = __webpack_public_path__ + "img/td2.1308454e.png";